<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
    <template #MODELTOP="{ params, visible }">
      <Form
        v-if="visible"
        ref="searchFrom"
        style="display: flex; justify-content: space-between; height: 40px"
      >
        <h3>
          {{ params.data.agent_name }}
        </h3>
        <FormItem>
          <Button
            v-if="$hasPermission(165)"
            type="warning"
            @click="freightruleAdd(params.data)"
            icon="md-add"
          >
            {{ $t("add") }}
          </Button>
        </FormItem>
      </Form>
    </template>
  </cTable>
</template>

<script>
import {
  add,
  getAgent,
  getDetails,
  update,
  del,
  updateFlie,
	updateFlieContract,
	save,
	getContract,
	delContract,
	contact,
	contactSave,
	bank,
	bankSave,
	bankDel,
	cancel
} from "@/api/tracker/agent";
import { getCurrency } from '@/api/finance/currency'
import { getCountry } from "@/api/system/country";
import { getSelAgent, billingCycle } from "@/api/public";
import {
  addParams,
  getParams,
  getParamsDetails,
  updateParams,
  delParams,
} from "@/api/tracker/params";
import {
  getContractParams,
} from "@/api/user/contract";
import cTable from "@/base/common/index";
export default {
  name: "agent",
  components: {
    cTable,
  },
  async mounted() {
    let agentType = await this.$sel.getData("OMS_AGENT_TYPE");
    let Country = (await getCountry()).data.payload.rows;
    let Currency = (await getCurrency()).data.payload.rows;
    this.header.searchs.forEach((item) => {
      if (item.key === "agent_type") item.options = agentType;
    });
    this.modals.add.fields.forEach((item) => {
      if (item.key === "agent_type") item.options = agentType;
      if (item.key === "country") item.options = Country.map(t=>({
				label:t.code,
				value:t.code
			}));
    });
		this.modals.addBank.fields.forEach((item) => {
		  if (item.key === "currency") item.options = Currency.map(t=>({
				label:t.code,
				value:t.code
			}));
		  if (item.key === "bank_country") item.options = Country.map(t=>({
				label:t.code,
				value:t.code
			}));
		});
  },
  methods: {
    freightruleAdd(data) {
      this.$refs["table"]
        .getModal("addParams")
        .setTitle(this.$t("add") + this.$t("freightrule"));
      this.$refs["table"].getModal("addParams").open({ agent_id: data.id });
    },
  },
  data() {
    let typesType = [
				{ label: this.$t("orther"), value: "OTHER" },
        { label: this.$t("clearance"), value: "CLEARANCE" },
        { label: this.$t("courier"), value: "DELIVERY" },
        { label: this.$t("all"), value: "ALL_SUPPORT" },
      ],
      statusList = [
        { label: this.$t("YES"), value: "YES" },
        { label: this.$t("NO"), value: "NO" },
      ],
      typeList = [
        {
          label: "CREATE",
          value: "CREATE",
        },
        {
          label: "LABEL",
          value: "LABEL",
        },
        {
          label: "CLEARANCE",
          value: "CLEARANCE",
        },
        {
          label: "TRACK",
          value: "TRACK",
        },
      ],
      globalUrl = this.$globalUrl;
    return {
      methods: {
        list: getAgent,
        updateFlie,
        add,
        update,
        getDetails,
        del,
        freigList: getParams,
				getContract,
        addParams,
        getParamsDetails,
        updateParams,
        delParams,
				getContractParams,
				billingCycle,
				updateFlieContract,
				save,
				delContract,
				contact,
				contactSave,
				bank,
				bankSave,
				bankDel,
				cancel
      },
      modals: {
        add: {
					type:'add',
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods(row.id ? "update" : "add", row, true)
                .then((e) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          footer: {
            ok: {},
            cancel: {},
          },
          config: {
            modalBind: {
              width: 600,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              agent_name: [
                {
                  required: true,
                  type: "string",
                  message: "agent_name cannot be empty",
                  trigger: "blur",
                },
              ],
              agent_type: [
                {
                  required: true,
                  type: "number",
                  message: "agent_types cannot be empty",
                  trigger: "change",
                },
              ],
              types: [
                {
                  required: true,
                  type: "string",
                  message: "packet type cannot be empty",
                  trigger: "change",
                },
              ],
              telephone: [
                {
                  required: true,
                  message: "telephone cannot be empty",
                  trigger: "change",
                },
              ],
              status: [
                {
                  required: true,
                  type: "string",
                  message: "status cannot be empty",
                  trigger: "change",
                },
              ],
							country: [
							  {
							    required: true,
							    type: "array",
							    message: "cannot be empty",
							    trigger: "change",
							  },
							],
            },
          },
          grid: [
            { agent_name: 24 },
            { country: 24 },
            { telephone: 24 },
            { agent_logo: 24 },
            { agent_type: 24 },
            { types: 24 },
            { status: 24 },
          ],
          fields: [
            {
              key: "agent_name",
              name: () => this.$t("agentName"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("agentName");
              },
            },
            {
              key: "telephone",
              name: () => this.$t("telephone"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("telephone");
              },
            },
            {
              key: "agent_logo",
              name: () => this.$t("agent_logo"),
              component: "Upload-img",
              methods: {
                beforeUpload({ row, file }) {
                  let formData = new FormData();
                  formData.append("file", file); // 文件对象
                  this.$page
                    .handleRequestMethods("updateFlie", formData, true)
                    .then((e) => {
                      row.agent_logo = e.payload.fileUrl;
                    });
                  return false;
                },
              },
            },
						{
						  key: "country",
						  name: () => this.$t("serviceCountry"),
						  component: "Select",
						  placeholder() {
						    return this.$t("select") + this.$t("serviceCountry");
						  },
							bind:{
								multiple:true
							},
							default:[],
						  options: [],
						},
            {
              key: "agent_type",
              name: () => this.$t("agentTypes"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("agentTypes");
              },
              options: [],
              methods: {
                // async list({ field }) {
                //   let res = await getSelAgent();
                //   field.options = res.data.payload;
                // },
                // "on-change"({ row, field, fields }) {
                //   fields.forEach(el => {
                //     if (el.key == "types") {
                //       if (row.agent_type == "bag") {
                //         el.show = () => true;
                //       } else {
                //         el.show = () => false;
                //       }
                //     }
                //   });
                // }
              },
            },
            {
              key: "types",
              name: () => this.$t("businessTypes"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("businessTypes");
              },
              options: typesType,
              default: "OTHER",
              // show: () => false
            },
            {
              key: "status",
              name: () => this.$t("status"),
              component: "Radio",
              options: statusList,
              default: "YES",
              bind: {
                border: true,
              },
            },
          ],
        },
        track: {
          methods: {
            ok({ row, close }) {
              this.$page.handleRequestMethods("addTrace", row).then((e) => {
                this.$page.getList();
                close();
              });
            },
          },
          footer: {
            ok: {},
            cancel: {},
          },
          config: {
            modalBind: {
              width: 540,
            },
            formBind: {
              labelWidth: 150,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              time: [
                {
                  required: true,
                  message: "Please select the date and Time",
                  trigger: "change",
                  type: "date",
                },
              ],
              status_code: [
                {
                  required: true,
                  message: "Please select the track",
                  trigger: "change",
                  type: "number",
                },
              ],
            },
          },
          grid: [{ time: 24 }, { status_code: 24 }],
          fields: [
            {
              key: "time",
              name: () => this.$t("select") + this.$t("time"),
              component: "DatePicker",
              placeholder() {
                return this.$t("select") + this.$t("start") + this.$t("time");
              },
              bind: {
                type: "datetime",
                options: {
                  disabledDate(time) {
                    return time.getTime() > Date.now();
                  },
                },
                clearable: false,
              },
            },
            // {
            //   key: "status_code",
            //   name: () => this.$t("tracker_description"),
            //   component: "Select",
            //   placeholder() {
            //     return this.$t("select") + this.$t("tracker_description");
            //   },
            //   options: trackList,
            //   config: {
            //     label({ row, field }) {
            //       return this.$t(row.label);
            //     }
            //   }
            // }
          ],
        },
        operate: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("handlePacking", row)
                .then((e) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          footer: {
            ok: {},
            cancel: {},
          },
          config: {
            modalBind: {
              width: 540,
            },
            formBind: {
              labelWidth: 150,
            },
            rowBind: {
              gutter: 20,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              package: [
                {
                  required: true,
                  message: "Please enter the package",
                  trigger: "blur",
                },
              ],
              type: [
                {
                  required: true,
                  message: "Please select the Type",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [
            {
              package: 24,
            },
            {
              type: 24,
            },
          ],
          fields: [
            {
              name: () => this.$t("enter") + this.$t("bagCode"),
              key: "package",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("bagCode");
              },
            },
            // {
            //   name: () => this.$t("type"),
            //   component: "Select",
            //   placeholder() {
            //     return this.$t("select") + this.$t("type");
            //   },
            //   key: "type",
            //   options: typeList,
            //   config: {
            //     label({ row, field }) {
            //       return this.$t(row.label);
            //     }
            //   }
            // }
          ],
        },
        showParams: {
          contentSlot: "MODELTOP",
          config: {
            listFn: "freigList",
            modalBind: {
              width: "80%",
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          footer: {
            show: false,
          },
          fields: [],
          table: {
            footer: {
              show: true,
            },
            config: {
              align: "center",
              height: 600,
            },
            fields: [
              {
                name: () => this.$t("paramsType"),
                key: "type",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("paramsUrl"),
                key: "url",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("paramsAccount"),
                key: "params_account",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("paramsPwd"),
                key: "params_password",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("paramsSet"),
                key: "params_secret",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                type: "btns",
                width: 250,
                name: () => this.$t("operation"),
                fixed: "right",
                list: [
                  {
                    name: () => this.$t("update"),
                    type: "update",
                    fnName: "updateFun",
                    id: 166,
                    bind: {
                      type: "success",
                    },
                  },
                  {
                    name: () => this.$t("delete"),
                    type: "delete",
                    fnName: "deleteFun",
                    id: 167,
                    bind: {
                      type: "error",
                    },
                  },
                ],

                methods: {
                  async updateFun({ row }) {
                    let res = await this.handleRequestMethods(
                      "getParamsDetails",
                      {
                        id: row.id,
                      }
                    );
                    this.getModal("addParams").setTitle(
                      this.$t("update") + this.$t("params")
                    );
                    this.getModal("addParams").open({
                      type: res.payload.type,
                      url: res.payload.url,
                      params_account: res.payload.params_account,
                      params_password: res.payload.params_password,
                      params_secret: res.payload.params_secret,
                      id: row.id,
                      agent_id: row.agent_id,
                    });
                  },
                  deleteFun({ row }) {
                    this.$Modal.confirm({
                      title:
                        this.$t("whether") +
                        this.$t("confirm") +
                        this.$t("delete") +
                        '"' +
                        row.params_account +
                        '"' +
                        this.$t("paramsAccount") +
                        "?",
                      onOk: () => {
                        this.handleRequestMethods(
                          "delParams",
                          {
                            id: row.id,
                          },
                          true
                        ).then((res) => {
                          // this.$Message.success(res.data.msg);
                          this.getModal("showParams").getList();
                        });
                      },
                    });
                  },
                },
              },
            ],
          },
        },
        addParams: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods(
                  row.id ? "updateParams" : "addParams",
                  row,
                  true
                )
                .then((e) => {
                  this.$page.getModal("showParams").getList();
                  close();
                });
            },
          },
          footer: {
            ok: {},
            cancel: {},
          },
          config: {
            modalBind: {
              width: 600,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              type: [
                {
                  required: true,
                  type: "string",
                  message: "type cannot be empty",
                  trigger: "blur",
                },
              ],
              url: [
                {
                  required: true,
                  type: "string",
                  message: "agent_types cannot be empty",
                  trigger: "blur",
                },
              ],
              params_account: [
                {
                  required: true,
                  type: "string",
                  message: "params_account cannot be empty",
                  trigger: "blur",
                },
              ],
              params_password: [
                {
                  required: true,
                  type: "string",
                  message: "params_password cannot be empty",
                  trigger: "blur",
                },
              ],
              params_secret: [
                {
                  required: true,
                  type: "string",
                  message: "params_secret cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [
            { type: 24 },
            { url: 24 },
            { params_account: 24 },
            { params_password: 24 },
            { params_secret: 24 },
          ],
          fields: [
            {
              key: "type",
              name: () => this.$t("paramsType"),
              component: "Select",
              placeholder() {
                return this.$t("enter") + this.$t("paramsType");
              },
              config: {
                label({ row }) {
                  return this.$t(row.label);
                },
              },
              options: typeList,
            },
            {
              key: "url",
              name: () => this.$t("paramsUrl"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("paramsUrl");
              },
            },
            {
              key: "params_account",
              name: () => this.$t("paramsAccount"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("paramsAccount");
              },
            },
            {
              key: "params_password",
              name: () => this.$t("paramsPwd"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("paramsPwd");
              },
            },
            {
              key: "params_secret",
              name: () => this.$t("paramsSet"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("paramsSet");
              },
            },
          ],
        },
				contract:{
					config: {
					  listFn: "getContract",
					  modalBind: {
					    width: "80%",
					  },
					  rowBind: {
					    gutter: 16,
					    style: {
					      marginBottom: "20px",
					    },
					  },
					},
					header:{
						show:()=>true,
						btns:[
							{
								name:this.$t('addContract'),
								type:'add',
								fnName:'add',
								bind: {
								  type: "warning",
								},
								id:1215
							}
						],
						methods:{
							add(){
								this.$page.getModal('addContract').open({agentId:this.params.id},function(){
									this.setTitle(this.$t('addContract'))
								})
								console.log('add');
							}
						}
					},
					footer: {
					  show: false,
					},
					fields: [],
					table: {
					  footer: {
					    show: true,
					  },
					  config: {
					    align: "center",
					    height: 600,
							rowClassName ({ row, rowIndex, }) {
								return row.status == 1?'custom-red':''
							}
					  },
					  fields: [
					    {
					      name: () => this.$t("agentName"),
					      key: "agent_name",
					      align: "center",
					      tooltip: true,
					      minWidth: 100,
					    },
							{
							  name: () => this.$t("billingCycle"),
							  key: "billing_cycle_txt",
							  align: "center",
							  tooltip: true,
							  minWidth: 100,
							},
							{
							  name: () => this.$t("contractHeader"),
							  key: "contract_header_txt",
							  align: "center",
							  tooltip: true,
							  minWidth: 100,
							},
							{
							  name: () => this.$t("contract_start_time"),
							  key: "start_time",
							  align: "center",
							  tooltip: true,
							  minWidth: 100,
							},
							{
							  name: () => this.$t("contract_end_time"),
							  key: "end_time",
							  align: "center",
							  tooltip: true,
							  minWidth: 100,
							},
							{
							  name: () => this.$t("Remarks"),
							  key: "remarks",
							  align: "center",
							  tooltip: true,
							  minWidth: 100,
							},
							{
							  name: () => this.$t("contract_src"),
							  key: "contract_src",
							  align: "center",
							  tooltip: true,
							  minWidth: 100,
								component:'Button',
								bind:{
									type:'primary',
									size:'small'
								},
								disabled({row}){
									return !row['contract_src']
								},
								methods:{
									render(){
										return '预览'
									},
									click({row}){
										window.open(globalUrl + row['contract_src'], "_blank");
									}
								}
							},
							{
							  name: () => this.$t("operate"),
							  key: "create_name",
							  align: "center",
							  tooltip: true,
							  minWidth: 100,
							},
							{
							  type: "btns",
							  width: 250,
							  name: () => this.$t("operation"),
							  fixed: "right",
							  list: [
									{
									  name: () => this.$t("update"),
									  type: "update",
									  fnName: "update",
									  id: 1215,
									  bind: {
									    type: "info",
									  },
									},
							    {
							      name: () => this.$t("delete"),
							      type: "del",
							      fnName: "del",
							      id: 1214,
							      bind: {
							        type: "error",
							      },
							    },
									{
									  name: () => this.$t("Invalid"),
									  type: "Invalid",
									  fnName: "Invalid",
										show({row}){
											return row.status != 1
										},
									  bind: {
									    type: "error",
									  },
									},
								],
								methods:{
									Invalid({row}){
										this.$Modal.confirm({
										  title:
										    this.$t("whether") +
										    this.$t("confirm") +
										    this.$t("Invalid") +
										    '"' +
										    row.agent_name +
										    '"' +
										    this.$t("agentT") +
										    "?",
										  onOk: () => {
										    this.handleRequestMethods('cancel',{id:row.id}).then(res=>{
										    	this.$Message.success(res.msg);
										    	this.getModal('contract').getList()
										    })
										  },
										});
									},
									update({row}){
										let data = JSON.parse(JSON.stringify(row))
										data.contract_src = {
											name:'合同文件',
											src:data.contract_src
										}
										data.agentId = this.getModal('contract').params.id
										this.getModal('addContract').open(data)
									},
									del({row}){
										this.$Modal.confirm({
										  title:
										    this.$t("whether") +
										    this.$t("confirm") +
										    this.$t("delete") +
										    '"' +
										    row.agent_name +
										    '"' +
										    this.$t("agentT") +
										    "?",
										  onOk: () => {
										    this.handleRequestMethods('delContract',{id:row.id}).then(res=>{
										    	this.$Message.success(res.msg);
										    	this.getModal('contract').getList()
										    })
										  },
										});
									}
								}
							}
						],
					}
				},
				addContract:{
					type:'add',
          methods: {
            ok({ row, close }) {
							let data = JSON.parse(JSON.stringify(row))
							data.contract_src = data.contract_src.src
              this.$page
                .handleRequestMethods(
                  'save',
									data
                )
                .then((e) => {
                  this.$page.getModal("contract").getList();
                  close();
                });
            },
          },
          footer: {
            ok: {},
            cancel: {},
          },
          config: {
            modalBind: {
              width: 600,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              contract_header: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
							billing_cycle: [
							  {
							    required: true,
							    type: "number",
							    message: "cannot be empty",
							    trigger: "blur",
							  },
							],
							start_time: [
							  {
							    required: true,
							    type: "date",
							    message: "cannot be empty",
							    trigger: "blur",
							  },
							],
							end_time: [
							  {
							    required: true,
									type: "date",
							    message: "cannot be empty",
							    trigger: "blur",
							  },
							],
							contract_src: [
							  {
							    required: true,
							    type: "object",
							    message: "cannot be empty",
							    trigger: "blur",
							  },
							],
						}
          },
          grid: [
						{ contract_header: 24 },
						{ billing_cycle: 24 },
						{ start_time: 24 },
						{ end_time: 24 },
						{contract_src:24},
						{ remarks: 24 }
          ],
          fields: [
						{
						  key: "contract_header",
						  name: () => this.$t("contract_title"),
						  component: "Select",
						  placeholder: () => this.$t("select") + this.$t("contract_title"),
						  options: [],
						  config: {
						    label: "title",
						    value: "id"
						  },
						  methods: {
						    async list({ field }) {
						      field.options = (
						        await this.$page.handleRequestMethods("getContractParams")
						      ).payload.header;
						      this.$forceUpdate();
						    }
						  }
						},
						{
						  key: "billing_cycle",
						  name: () => this.$t("billingCycle"),
						  component: "Select",
						  placeholder: () => this.$t("select") + this.$t("billingCycle"),
						  options: [],
						  methods: {
						    async list({ field }) {
						      field.options = (
						        await this.$page.handleRequestMethods("billingCycle")
						      ).payload;
						      this.$forceUpdate();
						    }
						  }
						},
						{
						  key: "start_time",
						  name: () => this.$t("contract_start_time"),
						  component: "DatePicker",
						  placeholder: () =>
						    this.$t("select") + this.$t("start") + this.$t("date"),
						  bind: {
						    style: {
						      width: "100%"
						    }
						  },
						  disabledDate: true
						},
						{
						  key: "end_time",
						  name: () => this.$t("contract_end_time"),
						  component: "DatePicker",
						  placeholder: () =>
						    this.$t("select") + this.$t("contract_end_time"),
						  bind: {
						    style: {
						      width: "100%"
						    }
						  },
						  disabledDate: true
						},
						{
						  key: "remarks",
						  name: () => this.$t("contract_remark"),
						  placeholder: () => this.$t("enter") + this.$t("contract_remark"),
						  component: "Input",
						  bind: {
						    type: "textarea",
						    rows: 5
						  }
						},
            {
              name: () => this.$t("contract_src"),
              key: "contract_src",
              component: "Upload",
							files:[],
              bind: {
                fileName: "files",
								isButton:true,
                type: "select",
                // accept: ".xlsx,.xls",
                content: this.$t("uploadText") + this.$t("uploadTe"),
              },
              methods: {
								beforeUpload: ({ file }) => {
									let formData = new FormData()
									formData.append('file',file)
									updateFlieContract(formData).then(res=>{
										console.log(res);
										this.$refs["table"]
										  .getModal("addContract")
										  .setFormData({ contract_src: {
												src: res.data.payload,
												name: file.name,
											}})
									})
								  return false;
								},
							},
						}
          ],
        },
				contact:{
					type:'add',
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods('contactSave', row, true)
                .then((e) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          footer: {
            ok: {id:1226},
            cancel: {},
          },
          config: {
            modalBind: {
              width: 600,
            },
            formBind: {
              labelWidth: 120,
							disabled(){
								return !this.$hasPermission(1226)
							}
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              contact: [
                {
                  required: true,
                  type: "string",
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              business_phone: [
                {
                  required: true,
                  type: "string",
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [
            { contact: 24 },
            { business_phone: 24 },
            { business_mail: 24 },
            { cs_maill: 24 },
            { finance_mail: 24 },
            { remarks: 24 },
          ],
          fields: [
            {
              key: "contact",
              name: () => this.$t("Contacts"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("Contacts");
              },
            },
						{
						  key: "business_phone",
						  name: () => this.$t("BusinessPhone"),
						  component: "Input",
						  placeholder() {
						    return this.$t("enter") + this.$t("BusinessPhone");
						  },
						},
						{
						  key: "business_mail",
						  name: () => this.$t("BusinessMail"),
						  component: "Input",
						  placeholder() {
						    return this.$t("enter") + this.$t("BusinessMail");
						  },
						},
						{
						  key: "cs_maill",
						  name: () => this.$t("ServiceMail"),
						  component: "Input",
						  placeholder() {
						    return this.$t("enter") + this.$t("ServiceMail");
						  },
						},
						{
						  key: "finance_mail",
						  name: () => this.$t("financeEmail"),
						  component: "Input",
						  placeholder() {
						    return this.$t("enter") + this.$t("financeEmail");
						  },
						},
            {
              key: "remarks",
              name: () => this.$t("Contacts"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("Contacts");
              },
							bind:{
								type:'textarea',
								rows:5,
							}
            },
          ],
        },
				bank:{
          config: {
            listFn: "bank",
            modalBind: {
              width: "80%",
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          footer: {
            show: false,
          },
					header:{
						show:()=>true,
						btns:[
							{
								name:this.$t('add'),
								type:'add',
								fnName:'add',
								bind:{
									type:'primary'
								}
							}
						],
						methods:{
							add(){
								this.$page.getModal("addBank").setTitle(
								    this.$t("update") + this.$t("bankInfo")
								  );
								this.$page.getModal("addBank").open({agentId:this.$page.getModal("bank").params.id});
							}
						}
					},
          fields: [],
          table: {
            footer: {
              show: true,
            },
            config: {
              align: "center",
              height: 600,
            },
            fields: [
              {
                name: () => this.$t("ownerCountry"),
                key: "bank_country",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("bank"),
                key: "bank_name",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("BranchBank"),
                key: "bank_branch",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("bank_accounts"),
                key: "bank_account",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("bank_address"),
                key: "bank_address",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
							{
							  name: () => this.$t("AccountOpeningUsername"),
							  key: "cnaps_code",
							  align: "center",
							  tooltip: true,
							  minWidth: 100,
							},
							{
							  name: () => this.$t("BankCode"),
							  key: "bank_key",
							  align: "center",
							  tooltip: true,
							  minWidth: 100,
							},
							{
							  name: () => this.$t("cod_currency"),
							  key: "currency_txt",
							  align: "center",
							  tooltip: true,
							  minWidth: 100,
							},
							{
							  name: () => 'swift'+this.$t("code"),
							  key: "swift_code",
							  align: "center",
							  tooltip: true,
							  minWidth: 100,
							},
							{
							  name: () => this.$t("iban"),
							  key: "iban",
							  align: "center",
							  tooltip: true,
							  minWidth: 100,
							},
							{
							  name: () => this.$t("Remarks"),
							  key: "remarks",
							  align: "center",
							  tooltip: true,
							  minWidth: 100,
							},
              {
                type: "btns",
                width: 150,
                name: () => this.$t("operation"),
                fixed: "right",
                list: [
                  {
                    name: () => this.$t("update"),
                    type: "update",
                    fnName: "updateFun",
                    id: 1224,
                    bind: {
                      type: "success",
                    },
                  },
									{
									  name: () => this.$t("delete"),
									  type: "delete",
									  fnName: "delete",
									  id: 1223,
									  bind: {
									    type: "error",
									  },
									},
                ],
                methods: {
                  async updateFun({ row }) {
                    this.getModal("addBank").setTitle(
                      this.$t("update") + this.$t("bankInfo")
                    );
                    this.getModal("addBank").open({...row,agentId:this.getModal("bank").params.id});
                  },
									delete({row}){
										this.$Modal.confirm({
											title:
												this.$t("whether") +
												this.$t("confirm") +
												this.$t("delete") +
												"?",
											onOk: () => {
												this.handleRequestMethods(
													"bankDel",
													{
														id: row.id,
													},
													true
												).then((res) => {
													// this.$Message.success(res.data.msg);
													this.getModal("bank").getList()
												});
											},
										});
									}
                },
              },
            ],
          },
        },
				addBank:{
					type:'add',
				  methods: {
				    ok({ row, close }) {
				      this.$page
				        .handleRequestMethods('bankSave', row, true)
				        .then((e) => {
				          this.$page.getModal('bank').getList();
				          close();
				        });
				    },
				  },
				  footer: {
				    ok: {},
				    cancel: {},
				  },
				  config: {
				    modalBind: {
				      width: 800,
				    },
				    formBind: {
				      labelWidth: 120,
				    },
				    rowBind: {
				      gutter: 13,
				      style: {
				        marginBottom: "20px",
				      },
				    },
				    rules: {
				      bank_country: [
				        {
				          required: true,
				          message: "cannot be empty",
				          trigger: "blur",
				        },
				      ],
				      bank_name: [
				        {
				          required: true,
				          type: "string",
				          message: "cannot be empty",
				          trigger: "blur",
				        },
				      ],
							bank_account: [
							  {
							    required: true,
							    type: "string",
							    message: "cannot be empty",
							    trigger: "blur",
							  },
							],
							bank_address: [
							  {
							    required: true,
							    type: "string",
							    message: "cannot be empty",
							    trigger: "blur",
							  },
							],
							cnaps_code: [
							  {
							    required: true,
							    type: "string",
							    message: "cannot be empty",
							    trigger: "blur",
							  },
							],
				    },
				  },
				  grid: [
				    { bank_country: 24 },
				    { bank_name: 12,bank_branch: 12 },
				    { bank_account: 12,bank_key: 12 },
						{ bank_address: 24 },
				    { cnaps_code: 24 },
				    { swift_code: 24 },
				    { iban: 24 },
				    { currency: 24 },
						{ remarks: 24 },
				  ],
				  fields: [
				 
						{
						  key: "bank_country",
						  name: () => this.$t("ownerCountry"),
						  component: "Select",
						  placeholder() {
						    return this.$t("enter") + this.$t("ownerCountry");
						  },
							bind:{
								multiple:false
							},
						},
						{
						  key: "bank_name",
						  name: () => this.$t("bank"),
						  component: "Input",
						  placeholder() {
						    return this.$t("enter") + this.$t("bank");
						  },
						},
						{
						  key: "bank_branch",
						  name: () => this.$t("BranchBank"),
						  component: "Input",
						  placeholder() {
						    return this.$t("enter") + this.$t("BranchBank");
						  },
						},
						{
						  key: "bank_account",
						  name: () => this.$t("bank_accounts"),
						  component: "Input",
						  placeholder() {
						    return this.$t("enter") + this.$t("bank_accounts");
						  },
						},
						{
						  key: "bank_address",
						  name: () => this.$t("bank_address"),
						  component: "Input",
						  placeholder() {
						    return this.$t("enter") + this.$t("bank_address");
						  },
						},
						{
						  key: "cnaps_code",
						  name: () => this.$t("AccountOpeningUsername"),
						  component: "Input",
						  placeholder() {
						    return this.$t("enter") + this.$t("AccountOpeningUsername");
						  },
						},
						{
						  key: "bank_key",
						  name: () => this.$t("BankCode"),
						  component: "Input",
						  placeholder() {
						    return this.$t("enter") + this.$t("BankCode");
						  },
						},
						{
						  key: "swift_code",
						  name: () => 'swift'+this.$t("code"),
						  component: "Input",
						  placeholder() {
						    return this.$t("enter") + 'swift'+this.$t("code");
						  },
						},
						{
						  key: "iban",
						  name: () => 'swift'+this.$t("iban"),
						  component: "Input",
						  placeholder() {
						    return this.$t("enter") + 'swift'+this.$t("iban");
						  },
						},
						{
						  key: "currency",
						  name: () => this.$t("cod_currency"),
						  component: "Select",
						  placeholder() {
						    return this.$t("select") + this.$t("cod_currency");
						  },
							bind:{
								multiple:true
							},
							default:[],
							options: [],
						},
				    {
				      key: "remarks",
				      name: () => this.$t("Remarks"),
				      component: "Input",
				      placeholder() {
				        return this.$t("enter") + this.$t("Remarks");
				      },
							bind:{
								type:'textarea',
								rows:5,
							}
				    },
				  ],
				},
      },
      header: {
        config: {
          custom: false,
        },
        searchs: [
          {
            key: "agent_type",
            placeholder() {
              return this.$t("select") + this.$t("agentTypes");
            },
            component: "Select",
            options: [],
            // default: "all",
          },
          {
            key: "status",
            placeholder() {
              return this.$t("select") + this.$t("status");
            },
            component: "Select",
            options: statusList,
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "addFun",
              id: 161,
              bind: {
                type: "warning",
                icon: "md-add",
              },
            },
          ],
          methods: {
            addFun({ field, searchForm }) {
              // console.log(this);
              this.getModal("add").open(null, function () {
                this.setTitle(this.$t("add"));
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          show: false,
        },
        {
          name: () => this.$t("agentName"),
          key: "agent_name",
          align: "left",
          minWidth: 150,
        },
        {
          name: this.$t("telephone"),
          key: "telephone",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("agentTypes"),
          key: "type_name",
          align: "center",
          minWidth: 120,
        },
        {
          name: () => this.$t("businessTypes"),
          key: "types",
          align: "left",
          minWidth: 120,
        },
        {
          name: () => this.$t("agent_logo"),
          key: "agent_logo",
          align: "center",
          minWidth: 100,
          component: "Button",
          bind: {
            type: "primary",
            size: "small",
          },
          methods: {
            render: ({ value }) => {
              return value ? "prview" : "--";
            },
            click({ row }) {
              window.open(globalUrl + row.agent_logo, "_blank");
            },
          },
          disabled({ row }) {
            return !row.agent_logo;
          },
        },
        {
          name: () => this.$t("status"),
          key: "status",
          align: "center",
          minWidth: 100,
          methods: {
            render({ value }) {
              return statusList.find((item) => item.value == value).label;
            },
          },
        },
				{
				  name: () => this.$t("serviceCountry"),
				  key: "country_txt",
				  align: "center",
				  minWidth: 120,
				},
				{
				  name: () => this.$t("createUser"),
				  key: "create_name",
				  align: "center",
				  minWidth: 120,
				},
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          align: "center",
          minWidth: 180,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            },
          },
        },
        {
          type: "btns",
          width: 250,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("freightrule"),
              type: "freightrule",
              fnName: "freightruleFun",
              id: 164,
              bind: {
                type: "info",
              },
            },
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              id: 162,
              bind: {
                type: "success",
              },
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              id: 163,
              fnName: "deleteFun",
              bind: {
                type: "error",
              },
            },
						{
							name:()=>this.$t('bindContract'),
							type:'contract',
							fnName:'contract',
							bind: {
							  type: "warning",
							},
							id:1216
						},
						{
							name:()=>this.$t('ContactInformation'),
							type:'contact',
							fnName:'contact',
							bind: {
							  type: "warning",
							},
							id:1227
						},
						{
							name:()=>this.$t('bankInfo'),
							type:'bank',
							fnName:'bank',
							bind: {
							  type: "warning",
							},
							id:1225
						}
          ],
          methods: {
						contact({row}){
							this.handleRequestMethods('contact',{id:row.id}).then(res=>{
								this.getModal('contact').open({...res.payload,agentId:row.id},function(){
									this.setTitle(`${row.agent_name}（${this.$t("ContactInformation")}）`);
								})
							})
						},
						bank({row}){
							this.getModal('bank').open({id:row.id},function(){
								this.pageConfig.data = { id:row.id };
								this.setTitle(`${row.agent_name}（${this.$t("bankInfo")}）`);
								this.getList();
							})
						},
						contract({row}){
							this.getModal('contract').open(row,function(){
								this.pageConfig.data = { id: row.id };
								this.setTitle(`${row.agent_name}（${this.$t("bindContract")}）`);
								this.getList();
							})
						},
            freightruleFun({ row }) {
              this.getModal("showParams").setTitle(this.$t("freightrule"));
              this.getModal("showParams").open({ data: row }, function () {
                this.pageConfig.data = { agent_id: row.id };
                this.getList();
              });
            },
            async updateFun({ row }) {
              this.handleRequestMethods("getDetails", {
                id: row.id,
              }).then((res) => {
								console.log();
                this.getModal("add").open(
                  {
                    agent_name: res.payload.agent_name,
                    telephone: res.payload.telephone,
                    agent_logo: res.payload.agent_logo,
                    agent_type: res.payload.agent_type,
                    types: res.payload.types,
                    status: res.payload.status,
                    country: res.payload.country,
                    id: row.id,
                  },
                  function () {
                    // this.fields.forEach(el => {
                    //   if (el.key == "types") {
                    //     if (res.payload.agent_type == "bag") {
                    //       el.show = () => true;
                    //     } else {
                    //       el.show = () => false;
                    //     }
                    //   }
                    // });
                    this.setTitle(this.$t("update"));
                  }
                );
              });
            },
            deleteFun({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("delete") +
                  '"' +
                  row.agent_name +
                  '"' +
                  this.$t("agentT") +
                  "?",
                onOk: () => {
                  this.handleRequestMethods(
                    "del",
                    {
                      id: row.id,
                    },
                    true
                  ).then((res) => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>
<style type="text/css">
/* @page{
    size: 7cm 8cm;
  } */
</style>
<style>
	 .custom-red {
		background-color: #f90 !important;
		color: #fff;
	}
</style>
